



































































import { Component, Prop, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import TipoTramiteComponentProp from "@/helpers/tipoTramiteComponentProp.helper";

@Component({})
export default class PerfilCiudadanoComponent extends BaseVue {
  @Prop() readonly cedula!: string;
  @Prop() readonly esBeneficiario!: boolean;
  @Prop() readonly esEvaluado!: boolean;
  @Prop() readonly esNoEvaluado!: boolean;
  @Prop() readonly esMiembro!: boolean;

  created() {
    const props = [
      new TipoTramiteComponentProp("cedula", "string", true, "C\u00e9dula"),
      new TipoTramiteComponentProp(
        "esBeneficiario",
        "boolean",
        true,
        "\u00bfEs beneficiario?"
      ),
      new TipoTramiteComponentProp("esEvaluado", "boolean", true, "\u00bfEs evaluado?"),
      new TipoTramiteComponentProp(
        "esNoEvaluado",
        "boolean",
        true,
        "\u00bfEs no evaluado?"
      ),
      new TipoTramiteComponentProp(
        "esMiembro",
        "boolean",
        true,
        "\u00bfEs miembro de un hogar?"
      )
    ];

    this.syncTieneHogar();
    this.$emit("render", props);
  }

  get permiteHacerTramite() {
    return !!this.$store.state.token;
  }

  get isTramite() {
    return this.$route.name === "nueva-solicitud";
  }

  get tieneHogar() {
    return this.esBeneficiario || this.esMiembro;
  }

  syncTieneHogar() {
    this.$store.commit("setTieneHogar", this.tieneHogar);
  }

  @Watch("esBeneficiario", { immediate: true })
  onEsBeneficiarioChange() {
    this.syncTieneHogar();
  }

  @Watch("esMiembro", { immediate: true })
  onEsMiembroChange() {
    this.syncTieneHogar();
  }

  goToTramite() {
    if (this.tieneHogar) this.$router.push(`nueva-solicitud`);
    else this.$router.push(`solicitud-de-evaluacion-del-hogar`);
  }
}
